import { useContext, createContext } from "react";

export type TranslationContext = {
  locale: string;
  t(value: string): string;
};

const defaultContext: TranslationContext = {
  locale: "en",
  t: (value) => value,
};

export const LocalizationContext =
  createContext<TranslationContext>(defaultContext);

export const useLocalizationContext = () => useContext(LocalizationContext);
